var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIconPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08265 0.117157C7.23886 0.273367 7.23886 0.526633 7.08265 0.682843L1.76549 6L7.08265 11.3172C7.23886 11.4734 7.23886 11.7266 7.08265 11.8828C6.92644 12.0391 6.67317 12.0391 6.51696 11.8828L0.916962 6.28284C0.760752 6.12663 0.760752 5.87337 0.916962 5.71716L6.51696 0.117157C6.67317 -0.0390524 6.92644 -0.0390524 7.08265 0.117157Z",
    fill: "#330072"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIconPurple);
export default __webpack_public_path__ + "static/media/backIconPurple.767a0b3b2fc3fc3f1e79b3001b186d5b.svg";
export { ForwardRef as ReactComponent };